import * as THREE from 'three';

interface Lights {
    directionalLight: THREE.DirectionalLight;
    ambientLight: THREE.AmbientLight;
    hemisphereLight: THREE.HemisphereLight;
}

export function createLights(scene: THREE.Scene): Lights {
    // 1. 방향성 조명 (태양)
    const directionalLight = new THREE.DirectionalLight(0xffffff, 1.5);
    directionalLight.position.set(20, 30, 10);
    directionalLight.castShadow = false; // 성능을 위해 그림자 끄기
    scene.add(directionalLight);

    // 2. 주변광 (전체적인 밝기)
    const ambientLight = new THREE.AmbientLight(0xffffff, 0.4);
    scene.add(ambientLight);

    // 3. 반구광 (하늘과 땅의 색상)
    const hemisphereLight = new THREE.HemisphereLight(
        0x87ceeb,  // 하늘 색상 (파란색)
        0x4a7c38,  // 땅 색상 (초록색)
        0.3
    );
    scene.add(hemisphereLight);

    return {
        directionalLight,
        ambientLight,
        hemisphereLight
    };
}
